import request from '@/utils/request'

// 获取投放组列表
export function getReleaseGroupList(params = {}) {
  return request({
    url: '/mini_program_report/release_group',
    method: 'get',
    params
  })
}

// 添加投放组
export function addReleaseGroup(data = {}) {
  return request({
    url: '/mini_program_report/release_group',
    method: 'post',
    data
  })
}
// 书籍
export function updateReleaseBookType(params = {}) {
  return request({
    url: `/mini_program_report/book_type`,
    method: 'get',
    params
  })
}

// 更新投放组
export function updateReleaseGroup(data = {}) {
  return request({
    url: `/mini_program_report/release_group/${data.id}`,
    method: 'PUT',
    data
  })
}

// 获取投放组投手列表
export function getListOfPitchersInTheLaunchGroup(params = {}) {
  return request({
    url: `/mini_program_report/release_group_user`,
    method: 'get',
    params
  })
}

// 添加投放组投手
export function addOfPitchersInTheLaunchGroup(data = {}) {
  return request({
    url: `/mini_program_report/release_group_user_add`,
    method: 'post',
    data
  })
}

// 删除投放组投手
export function deleteOfPitchersInTheLaunchGroup(data = {}) {
  return request({
    url: `/mini_program_report/release_group_user_del`,
    method: 'DELETE',
    data
  })
}

// 获取运营组列表
export function getOperationGroupList(params = {}) {
  return request({
    url: `/mini_program_report/operation_group`,
    method: 'GET',
    params
  })
}

// 添加运营组
export function addOperationGroup(data = {}) {
  return request({
    url: `/mini_program_report/operation_group`,
    method: 'post',
    data
  })
}

// 修改运营组
export function modifyOperationGroup(data = {}) {
  return request({
    url: `/mini_program_report/operation_group/${data.id}`,
    method: 'PUT',
    data
  })
}

// 获取运营者列表
export function getOperatorList(params = {}) {
  return request({
    url: `/mini_program_report/operation_group_user`,
    method: 'get',
    params
  })
}

// 添加运营者
export function addOperator(data = {}) {
  return request({
    url: `/mini_program_report/operation_group_user_add`,
    method: 'post',
    data
  })
}

// 删除运营者
export function deleteOperator(data = {}) {
  return request({
    url: `/mini_program_report/operation_group_user_del`,
    method: 'DELETE',
    data
  })
}

// 获取小说列表
export function getFictionList(params = {}) {
  return request({
    url: `/mini_program_report/novel_list`,
    method: 'get',
    params
  })
}

// 获取书籍归属列表
export function getBookOwnershipList(params = {}) {
  return request({
    url: `/mini_program_report/belong_list`,
    method: 'get',
    params
  })
}

// 添加书籍归属
export function addBookOwnership(data = {}) {
  return request({
    url: `/mini_program_report/add_belong_book`,
    method: 'post',
    data
  })
}

// 修改书籍归属
export function modifyBookOwnership(data = {}) {
  return request({
    url: `/mini_program_report/update_belong_book`,
    method: 'PUT',
    data
  })
}
// 删除书籍归属
export function deleteBooks(id) {
  return request({
    url: `/mini_program_report/del_belong_book?id=${id}`,
    method: 'delete'
  })
}

// 获取书名列表
export function getTitleList(params = {}) {
  return request({
    url: `/mini_program_report/book_alias_list`,
    method: 'get',
    params
  })
}

// 小说绑定书籍归属
export function novelsBoundToBooks(data = {}) {
  return request({
    url: `/mini_program_report/add_alias`,
    method: 'post',
    data
  })
}

// 删除小说绑定书籍归属
export function deleteNovelsBoundToBooks(data = {}) {
  return request({
    url: `/mini_program_report/del_alias`,
    method: 'DELETE',
    data
  })
}

// 投放位置列表
export function dropLocationList(params = {}) {
  return request({
    url: `/mini_program_report/positions`,
    method: 'get',
    params
  })
}

// 添加投放位置
export function addDropLocationList(data = {}) {
  return request({
    url: `/mini_program_report/positions`,
    method: 'post',
    data
  })
}

// 修改投放位置
export function modifyDropLocationList(data = {}) {
  return request({
    url: `/mini_program_report/positions/${data.id}`,
    method: 'put',
    data
  })
}

// 获取绑定关系列表
export function getBindingRelationList(params = {}) {
  return request({
    url: `/mini_program_report/bind_wechat`,
    method: 'get',
    params
  })
}

// 获取公众号列表
export function getTheListOfOfficialAccount(params = {}) {
  return request({
    url: `/mini_program_report/wechat_list`,
    method: 'get',
    params
  })
}

// 获取广告主
export function getAdvertiser(params = {}) {
  return request({
    url: `/mini_program_report/advertiser_list`,
    method: 'get',
    params
  })
}

// 添加投放关系
export function addReleaseRelationship(data = {}) {
  return request({
    url: `/mini_program_report/bind_wechat`,
    method: 'post',
    data
  })
}

// 修改投放关系
export function modifyReleaseRelationship(id, data = {}) {
  return request({
    url: `/mini_program_report/bind_wechat/${id}`,
    method: 'put',
    data
  })
}

// 删除投放关系
export function deleteReleaseRelationship(id) {
  return request({
    url: `/mini_program_report/bind_wechat/${id}`,
    method: 'DELETE'
  })
}

// 获取报表列表
export function getReportList(params = {}) {
  return request({
    url: `/mini_program_report/bind_wechat_report`,
    method: 'get',
    params
  })
}

// 导出报表
export function exportReport(data = {}) {
  return request({
    url: `/mini_program_report/export_bind_data`,
    method: 'post',
    data
  })
}
// 广告主消耗导出报表
export function exportAdq(data = {}) {
  return request({
    url: `/mini_program_report/export_bind_data_advertiser`,
    method: 'post',
    data
  })
}
// 修改消耗
export function modifyConsumption(data = {}) {
  return request({
    url: `/mini_program_report/edit_consume`,
    method: 'PUT',
    data
  })
}

// 修改RIO标准
export function modifyStandard(data = {}) {
  return request({
    url: `/mini_program_report/edit_roi_standard`,
    method: 'PUT',
    data
  })
}
// 获取总计报表列表
export function getTotalReportList(params = {}) {
  return request({
    url: `/mini_program_report/bind_wechat_total_report`,
    method: 'get',
    params
  })
}

// 导出总计报表
export function exportTotalReport(data = {}) {
  return request({
    url: `/mini_program_report/export_bind_total_data`,
    method: 'POST',
    data
  })
}

// 获取平台
export function getPlatform(params = {}) {
  return request({
    url: `/common/specific_platform_list`,
    method: 'get',
    params
  })
}

// T图列表
export function tFigureList(params = {}) {
  return request({
    url: `/mini_program_report/bind_wechat_t_report`,
    method: 'get',
    params
  })
}

// 导出T图列表
export function exportTFigureList(data = {}) {
  return request({
    url: `/mini_program_report/export_bind_t_data`,
    method: 'post',
    data
  })
}

// 更新
export function toUpdate(params = {}) {
  return request({
    url: `/mini_program_report/bind_wechat_t_report_update`,
    method: 'get',
    params
  })
}

export function launchTeamLeader(params = {}) {
  return request({
    url: `/mini_program_report/release_group_leader`,
    method: 'get',
    params
  })
}

// 删除投放组
export function deleteMy(id) {
  return request({
    url: `/mini_program_report/release_group/${id}`,
    method: 'delete'
  })
}

// 删除运营组
export function deleteOperationGroup(id) {
  return request({
    url: `/mini_program_report/operation_group/${id}`,
    method: 'delete'
  })
}
// 阈值配置列表
export function thresholdlist(params = {}) {
  return request({
    url: `/mini_program_report/bind_threshold_configs`,
    method: 'get',
    params
  })
}
// 阈值配置添加
export function bindthresholdconfigs(data = {}) {
  return request({
    url: `/mini_program_report/bind_threshold_configs`,
    method: 'POST',
    data
  })
}
// 阈值配置修改
export function editbindthresholdconfigs(id, data = {}) {
  return request({
    url: `/mini_program_report/bind_threshold_configs/${id}`,
    method: 'put',
    data
  })
}
// 阈值配置删除
export function deletebindthresholdconfigs(id) {
  return request({
    url: `/mini_program_report/bind_threshold_configs/${id}`,
    method: 'delete'
  })
}
// 飞书用户列表
export function feishuuserlist(params = {}) {
  return request({
    url: `/mini_program_report/feishu_user`,
    method: 'get',
    params
  })
}
// 分组导出
export function bindwechatreportnew(params = {}) {
  return request({
    url: `/mini_program_report/bind_wechat_report_new`,
    method: 'get',
    params
  })
}
// 用户QQ关联的广告组
export function adgroupsList(params = {}) {
  return request({
    url: `/ad_management/account/adgroups/index`,
    method: 'get',
    params
  })
}
// 查找用户自建的资产
export function account_asset_info(params = {}) {
  return request({
    url: `/ad_management/account/adgroups/account_asset_info`,
    method: 'get',
    params
  })
}
// 批量更新用户QQ下的广告组
export function batch_update_adgroup_account(data = {}) {
  return request({
    url: `/ad_management/account/adgroups/batch_update_adgroup_account`,
    method: 'POST',
    data
  })
}
// 查找广告组修改记录
export function select_adgroups_record(params = {}) {
  return request({
    url: `/ad_management/account/adgroups/select_adgroups_record`,
    method: 'get',
    params
  })
}
// 新广告配置信息（公共）
export function adq_config_text(params = {}) {
  return request({
    url: `/ad_management/template/ads_template/adq_config_text`,
    method: 'get',
    params
  })
}
//
export function regions(params = {}) {
  return request({
    url: `/delivery_auxiliary/regions`,
    method: 'get',
    params
  })
}
// 导出广告主消耗导出报表
export function exportbinddataadvertiser(data = {}) {
  return request({
    url: `/mini_program_report/export_bind_data_advertiser`,
    method: 'POST',
    data
  })
}

// 切换同组查看权限
export function releaseSetSameGroup(data = {}) {
  return request({
    url: `/mini_program_report/release_set_same_group`,
    method: 'POST',
    data
  })
}
// 获取投放组列表
export function getReleaseGroupListiaa(params = {}) {
  return request({
    url: '/mini_program_report/release_group',
    method: 'get',
    params
  })
}
// 获取投放组投手列表
export function getListOfPitchersInTheLaunchGroupiaa(params = {}) {
  return request({
    url: `/mini_program_report/release_group_user`,
    method: 'get',
    params
  })
}
// 导出总计报表(新)
export function exportTotalReportnew(data = {}) {
  return request({
    url: `/mini_program_report/exportTotalV2`,
    method: 'POST',
    data
  })
}
// 获取配置
export function commonreportoptions(params = {}) {
  return request({
    url: `/common/report_options`,
    method: 'get',
    params
  })
}
// 违规单据导出
export function accountpunishexport(data = {}) {
  return request({
    url: `/ad_management/account_punish/export`,
    method: 'POST',
    data
  })
}
// 分组导出
export function exportDifferentDimensionV2(data = {}) {
  return request({
    url: `/mini_program_report/exportDifferentDimensionV2`,
    method: 'POST',
    data
  })
}
// 导出报表V2(新)
export function exportReportV2(data = {}) {
  return request({
    url: `/mini_program_report/exportBindDataV2`,
    method: 'post',
    data
  })
}
// 广告主消耗导出（新）
export function exportbinddataadvertiserV2(data = {}) {
  return request({
    url: `/mini_program_report/exportBindDataAdvertiserV2`,
    method: 'post',
    data
  })
}
